import React from "react";
import styled, { css } from "styled-components";

import { HexTitleIcon } from "../../../hex-components/index.js";
import { numberWithCommas } from "../../../util/number.js";
import {
  homePageHorizontalPaddingStyles,
  homePageTopPaddingStyles,
} from "../../common/HomePageStyles.js";
import { Heading } from "../../Heading";

export interface HomeTabTitleProps {
  leftAction?: React.ReactNode;
  rightAction?: React.ReactNode;
  helpText?: React.ReactNode;
  bottomBar?: React.ReactNode;
  icon?: React.ReactNode;
  iconColor?: string;
  text: string;
  totalCount?: number | null;
  showTotalCount?: boolean;
  small?: boolean;
}

export const HomeTabTitle2: React.FunctionComponent<HomeTabTitleProps> = ({
  bottomBar = null,
  helpText,
  icon,
  iconColor,
  leftAction = null,
  rightAction = null,
  showTotalCount = false,
  small = false,
  text,
  totalCount,
}) => {
  return (
    <Wrapper $small={small} as="header">
      <HeaderContent>
        <div>
          <FlexDiv>
            {icon && (
              <HexTitleIcon
                color={iconColor}
                css={`
                  margin-right: 8px;
                `}
              >
                {icon}
              </HexTitleIcon>
            )}
            <Heading renderAs={small ? "h4" : "h3"}>{text}</Heading>
            {leftAction && <LeftAction>{leftAction}</LeftAction>}
          </FlexDiv>
          {showTotalCount && (
            <Total>
              {numberWithCommas(totalCount != null ? totalCount : 0)} item
              {totalCount === 1 ? "" : "s"}
            </Total>
          )}
          {helpText != null && <HelpText>{helpText}</HelpText>}
        </div>
        <RightActionWrapper>{rightAction}</RightActionWrapper>
      </HeaderContent>
      {bottomBar}
    </Wrapper>
  );
};

const Wrapper = styled.div<{ $small: boolean }>`
  display: flex;
  justify-content: center;
  flex-direction: column;

  ${({ $small }) =>
    !$small &&
    css`
      gap: 6px;
      padding-bottom: 12px;
      ${homePageTopPaddingStyles}
      ${homePageHorizontalPaddingStyles}
    `}
`;

const FlexDiv = styled.div`
  display: flex;
  align-items: center;
  flex: 1 1 auto;
`;

const LeftAction = styled.div`
  padding-left: 12px;
`;

const HeaderContent = styled(FlexDiv)`
  align-items: flex-end;

  @media (max-width: ${({ theme }) => `${theme.mediaQuery.EXTRA_SMALL}px`}) {
    display: block;
  }
`;

const RightActionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 6px;
  flex: 1 1 auto;
`;

const Total = styled.div`
  color: ${({ theme }) => theme.fontColor.MUTED};
  font-size: ${({ theme }) => theme.fontSize.SMALL};
  font-weight: ${({ theme }) => theme.fontWeight.MEDIUM};
  margin: 10px 0 0 4px;
`;

const HelpText = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${({ theme }) => theme.fontSize.SMALL};
  color: ${({ theme }) => theme.fontColor.MUTED};
  margin-top: 12px;
  margin-left: 4px;
`;
